import TrainingProfileForm from "./TrainingProfileForm";

export default function TrainingProfileSectionScreen({
  title,
  description,
  sectionId,
  draft,
  onChange,
  fieldErrors,
  options,
  showTitle = true,
}) {
  return (
    <div className="space-y-6">
      {showTitle ? (
        <div>
          <p className="lz-settings-header__eyebrow">Training Profile</p>
          <h2 className="lz-settings-header__title">{title}</h2>
          {description ? <p className="lz-settings-hint">{description}</p> : null}
        </div>
      ) : description ? (
        <p className="lz-settings-hint">{description}</p>
      ) : null}

      <TrainingProfileForm
        sectionId={sectionId}
        draft={draft}
        onChange={onChange}
        fieldErrors={fieldErrors}
        options={options}
      />
    </div>
  );
}
